import type {DashboardWhatsNewItem} from "./types";

export const PRE_EBIRD_LIST_BUILDING_LABEL = 'Pre eBird (List Building)';

export const DASHBOARD_WHATS_NEW_ITEMS: DashboardWhatsNewItem[] = [
    {
        title: 'Upcoming Targets on the dashboard',
        description: 'Your dashboard now previews recurring nearby birds due now or coming soon, with recent local sightings and a direct link to the full target list.'
    },
    {
        title: 'Upcoming Targets',
        description: 'Discover birds your past first-sighting patterns suggest may be worth looking for now or over the next few weeks.'
    },
    {
        title: 'More accurate milestones and yearly totals',
        description: 'Big Year, Dashboard, and Life Journey now share the same countable-species rules. Life Journey also correctly identifies the first species to reach a multi-state milestone.'
    },
    {
        title: 'Richer Calendar and species activity views',
        description: 'Calendar Year view now highlights fuller birding days, First of Year birds lead each day’s species list, and Species Detail adds an all-time weekly activity heatmap.'
    },
    {
        title: 'New Calendar Explorer',
        description: 'Explore your birding history by month or year, review daily checklists and milestones, and open a selected day directly on the map.'
    },
    {
        title: 'More achievements and progress detail',
        description: 'Added new habitat, region, challenge, and media achievements, along with detailed progress sidebars.'
    },
    {
        title: 'Family Explorer refinements',
        description: 'Improved Family Explorer filtering, image attribution, and layout.'
    },
    {
        title: 'New habitat types added',
        description: 'Hotspot habitat classification now recognizes additional derived habitat types for more accurate local habitat summaries.'
    },
    {
        title: 'Family Explorer filters are linkable',
        description: 'Seen, Not Seen, and related Family Explorer filters now persist in the URL so filtered views can be refreshed or shared.'
    },
    {
        title: 'Clearer Family Explorer cards',
        description: 'Birds you have not seen yet no longer appear faded, while still keeping their Not Seen labels and filters.'
    },
    {
        title: 'Bugfix: Pre-eBird List Building Checklists',
        description: 'BirdMap Explorer can now correctly handle birds entered manually into eBird as List-Building Checklists.'
    },
    {
        title: 'Smarter Family Explorer search',
        description: 'Family Explorer search now finds species or families.'
    },
    {
        title: 'Hotspot Explorer period switcher',
        description: 'Hotspot Explorer now allows filtering your visited locations by year and month.'
    },
    {
        title: 'Lifers-only map filter',
        description: 'Map Explorer\'s Year Mode now includes a Lifers only toggle so you can focus on just life birds seen in a given timeframe.'
    },
    {
        title: 'Bugfix: incorrect year totals',
        description: 'Fixed a bug that was causing uncalibrated year totals to be much higher than expected.'
    },
    {
        title: 'Calibrate your eBird data',
        description: 'A new optional calibration flow helps BirdMap Explorer handle exotic and naturalized species more accurately.'
    },
    {
        title: 'Data freshness on the dashboard',
        description: 'The dashboard now shows when your eBird data was last refreshed and when calibration was last applied.'
    },
    {
        title: 'Dashboard stat shortcuts',
        description: 'The "Your Year So Far" stats now link to the most relevant map or hotspot views.'
    }
];
